var Product = {
/*
	 * Sticky "Shop" Bar in product.liquid
	 * Hidden via CSS under 768px viewport size
	 */
	shopBar: function() {
		var product = JSON.parse(document.getElementById( 'product-json' ).innerHTML);
		var $shopBar = $('#add-to-cart-bar');
		var $selectors = $( 'select', $shopBar );

		new Shopify.OptionSelectors('product-bar-select', {
			product: product,
			onVariantSelected: Product.selectCallback
		});

		manageOptions( product );

		function manageOptions( obj ) {
			if (obj['options'].length === 1 && obj['variants'].length){
				if (obj['variants'][0].title === 'Default Title') {
					for (i = 0; i < obj['options'].length; i++) {
						$('#product-bar-select-option-'+[i]).closest('.productForm-block').hide();
					}
				} else {
					for (i = 0; i < obj['options'].length; i++) {
						$('#product-bar-select-option-'+[i]).closest('.selector-wrapper').attr('data-id', '#product-bar-select-option-'+[i]).prepend('<span class="selectArrow"></span><label>'+obj['options'][0]+'</label>');
					}
				}
			} else if (obj['options'].length > 1){
				for (i = 0; i < obj['options'].length; i++) {
					$('#product-bar-select-option-'+[i]).closest('.selector-wrapper').attr('data-id', '#product-bar-select-option-'+[i]).prepend('<span class="selectArrow"></span>');
				}
			}
		}
	}
}


$(document).ready(function() {

  (function($) {

    $(window).scroll(function(){    
      if($(this).scrollTop()>50){
        $(".product-bar").addClass("block animated fadeInDown");
        $(".sticky-header").addClass("quite");
      } else {
        $(".product-bar").removeClass("block animated fadeInDown");
      }
    });
    
    $(window).scroll(function(){    
      if( $(this).scrollTop() > 50 && window.innerWidth <= 425 ){
        $(".product-bar").removeClass("fadeInDown");
        $(".product-bar").addClass("block fadeInUp");
      } else {
        $(".product-bar").removeClass("fadeInUp");
      }
    });


    $(window).scroll(function(){    
      if($(this).scrollTop()>50){
        $(".header").removeClass("is-ticky animated fadeInDown");
      }
    });


  })(jQuery);
});